const $ = require('jquery');
const $container = $('.js-billboard-slideshow');

require('slippry/src/slippry');

$container.slippry({
	slippryWrapper: `<div class='sy-box  [  c-billboard__image  c-billboard__image--limit-width  ]  u-margins-off-deep' />`,
	elements: 'div',
  adaptiveHeight: false,
  captions: false,
  pager: false,
  controls: false,
  autoHover: false,
  transition: 'kenburns',
  kenZoom: 150,
  speed: 4000
});

$('.js-billboard-preload-image').each(function() {
	const $container = $(this);
	const $img = $container.find('img').first();
	const img = new Image();

	img.addEventListener('load', () => {
		$container.addClass('is-ready');
	});

	img.src = $img.attr('src');
});

$('.js-billboard-preload-background-image').each(function() {
	const $container = $(this);
	const img = new Image();

	img.addEventListener('load', () => {
		$container.addClass('is-ready');
	});

	img.src = $container.data('preload-src');
});

$('.js-billboard-preload-video').each(function() {
	const $container = $(this);
	const video = $(this).find('video')[0];

	const onReady = () =>
		$container.addClass('is-ready');

	if(video.readyState >= video.HAVE_FUTURE_DATA) {
		onReady();
	}

	video.addEventListener('canplay', onReady);
});